import React from "react";
import { Empty, Scrollbar, theme } from "codeArt/components/Base";
import Portal from "codeArt/components/Portal";
import { AreaChart, ChartYHanle, ManyAxisAreaChart } from "./common";
import { runtime, threePosition, Util } from "codeArt/common";
import ReactEcharts from "echarts-for-react";
import { DashedPanel } from "codeArt/components/accessory";

export class OEEChart extends AreaChart {
  constructor(props) {
    super(props);
    this.title = "OEE";
    this.unit = "比率";
    this.yName = "OEE";
    this.yHanle = ChartYHanle.ratio100;
  }

  getMarkData() {
    return { handle: "last" };
  }
}

export class LastOEEChart extends AreaChart {
  constructor(props) {
    super(props);
    this.title = "OEE";
    this.unit = "比率";
    this.yName = "OEE";
    this.yHanle = ChartYHanle.ratio100;
  }

  getX() {
    return [15, 30, 45, 60];
  }
}

/* export class OutStickRateChart extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { data } = this.props;
    let empty = data ? false : true;
    return (
      <DashedPanel
        title={this.title}
        empty={"不适用"}
        line={empty}
        className="h-100"
      >
        {empty ? null : (
          <ManyAxisAreaChart
            legend={true}
            legendTop={10}
            data={{
              y: [
                {
                  yAxisIndex: 0,
                  name: "总产量",
                  color: theme.color.blue,
                  data: data[0],
                  format: v => {
                    return threePosition(v);
                  }
                },
                {
                  yAxisIndex: 0,
                  name: "合格的产量",
                  color: theme.color["m-success"],
                  data: data[1],
                  format: v => {
                    return threePosition(v);
                  }
                },
                {
                  yAxisIndex: 1,
                  name: "出棒率",
                  color: theme.color["r-orange"],
                  data: data[2]
                }
              ],
              x: ["8:00", "9:00", "10:00", "11:00", "12:00"]
            }}
            grid={{ left: "25", right: "30", top: "40", bottom: "0" }}
            y={[
              {
                name: "总产量[支]",
                nameLocation: "center",
                nameGap: 63,
                min: 0,
                max: 1000000,
                interval: 200000,
                axisLine: { show: true },
                axisTick: { show: true },
                format: v => {
                  return threePosition(v);
                }
              },
              {
                name: "出棒率[kg/10,000支]",
                nameLocation: "center",
                nameGap: 35,
                min: 0,
                max: 1,
                interval: 0.2,
                axisLine: { show: true },
                axisTick: { show: true }
              }
            ]}
          />
        )}
      </DashedPanel>
    );
  }
} */


export class SpeedChart extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { data } = this.props;
    let empty = data ? false : true;
    return (
      <DashedPanel
        title={this.title}
        empty={"不适用"}
        line={empty}
        className="h-100"
      >
        {empty ? null : (
          <ManyAxisAreaChart
            legend={true}
            legendTop={10}
            data={{
              y: [
                {
                  yAxisIndex: 0,
                  name: "支/分钟",
                  color: theme.color.blue,
                  data: data[0],
                  format: v => {
                    return threePosition(v);
                  }
                },
                {
                  yAxisIndex: 1,
                  name: "米/分钟",
                  color: theme.color["m-success"],
                  data: data[1],
                  format: v => {
                    return threePosition(v);
                  }
                }
              ],
              x: ["8:00", "9:00", "10:00", "11:00", "12:00"]
            }}
            grid={{ left: "30", right: "30", top: "40", bottom: "0" }}
            y={[
              {
                name: "速度/支[分钟]",
                nameLocation: "center",
                nameGap: 48,
                min: 3000,
                max: 6000,
                interval: 600,
                axisLine: { show: true },
                axisTick: { show: true },
                format: v => {
                  return threePosition(v);
                }
              },
              {
                name: "速度/米[分钟]",
                nameLocation: "center",
                nameGap: 40,
                min: 200,
                max: 300,
                interval: 20,
                axisLine: { show: true },
                axisTick: { show: true },
                format: v => {
                  return threePosition(v);
                }
              }
            ]}
          />
        )}
      </DashedPanel>
    );
  }
}

export class OperationHoursChart extends AreaChart {
  constructor(props) {
    super(props);
    /*  this.title = "运行时间"; */
    this.unit = "小时";
    this.yName = "运行时间[小时]";
    this.yHanle = ChartYHanle.float;
  }

  getX() {
    return ["07/21", "07/21", "07/22", "07/24", "07/25"];
  }

  getGrid() {
    if (runtime.mobile)
      return { left: '5', right: '0', bottom: '0' };
  }
}

export class OEEDayChart extends AreaChart {
  constructor(props) {
    super(props);
    this.title = "OEE";
    this.unit = "比率";
    this.yName = "OEE";
    this.yHanle = ChartYHanle.ratio100;
  }

  getX() {
    return ["07/21", "07/22", "07/23", "07/24", "07/25"];
  }

  getGrid() {
    return { left: "10", right: "10", top: "20", bottom: "15" };
  }
}

export class MTBTChart extends AreaChart {
  constructor(props) {
    super(props);
    this.title = "平均无故障时间";
    this.unit = "小时";
    this.yName = "平均无故障时间[小时]";
    this.yHanle = ChartYHanle.float;
  }

  getX() {
    return ["07/21", "07/22", "07/23", "07/24", "07/25"];
  }

  getGrid() {
    return { left: "20", right: "10", top: "20", bottom: "15" };
  }
}

export class PerformanceChart extends AreaChart {
  constructor(props) {
    super(props);
    this.title = "性能";
    this.unit = "性能";
    this.yName = "性能[%]";
    this.yHanle = ChartYHanle.ratio100;
  }

  getX() {
    return ["07/21", "07/22", "07/23", "07/24", "07/25"];
  }

  getGrid() {
    return { left: "10", right: "10", top: "20", bottom: "15" };
  }
}

export class AvailabilityChart extends AreaChart {
  constructor(props) {
    super(props);
    this.title = "可用性";
    this.unit = "可用性";
    this.yName = "可用性[%]";
    this.yHanle = ChartYHanle.ratio100;
  }

  getX() {
    return ["07/21", "07/22", "07/23", "07/24", "07/25"];
  }

  getGrid() {
    return { left: "10", right: "10", top: "20", bottom: "15" };
  }
}

export class QualityChart extends AreaChart {
  constructor(props) {
    super(props);
    this.title = "质量";
    this.unit = "质量";
    this.yName = "质量[%]";
    this.yHanle = ChartYHanle.ratio100;
  }

  getX() {
    return ["07/21", "07/22", "07/23", "07/24", "07/25"];
  }

  getGrid() {
    return { left: "10", right: "10", top: "20", bottom: "15" };
  }
}

export class TimeUtilizationChart extends AreaChart {
  constructor(props) {
    super(props);
    this.title = "时间利用率";
    this.unit = "利用率";
    this.yName = "时间利用率[%]";
    this.yHanle = ChartYHanle.ratio100;
  }

  getX() {
    return ["07/21", "07/22", "07/23", "07/24", "07/25"];
  }

  getGrid() {
    return { left: "10", right: "10", top: "20", bottom: "15" };
  }
}

export class EffectChart extends AreaChart {
  constructor(props) {
    super(props);
    this.title = "效率";
    this.unit = "效率";
    this.yName = "效率[%]";
    this.yHanle = ChartYHanle.ratio100;
  }

  getX() {
    return ["07/21", "07/22", "07/23", "07/24", "07/25"];
  }

  getGrid() {
    return { left: "10", right: "10", top: "20", bottom: "15" };
  }
}
